export default __webpack_public_path__ + "static/media/techfest-tublian.fd8efbdf.jpg";